import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation } from '@tanstack/vue-query'

export const useObjectTypeDelete = (id: number, objectId: number) => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: () => http.del(`/inventory/group/${objectId}/object-types/${id}`),
  })

  const remove = async () => {
    try {
      await mutation.mutateAsync()

      addSuccess(trs('itf.inventory_object_types_deleted'))
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    remove,
  }
}
